
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/txs",
      function () {
        return require("private-next-pages/txs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/txs"])
      });
    }
  